import React from 'react';
import {connect} from 'react-redux';
import {BrowserRouter as Router, Route} from 'react-router-dom';
import IdleTimer from 'react-idle-timer'

import {Container} from 'semantic-ui-react';

import Navigation from './common/Navigation';

import Dashboard from './routes/Dashboard';
import Participants from './routes/Participants';

import SignIn from './routes/SignIn';
import SignInByToken from './routes/SignInByToken';
import SignUp from './routes/SignUp';
import PasswordRecovery from './routes/PasswordRecovery';
import Application from "./routes/Application";
import ApplicationList from "./routes/ApplicationList";
import ApplicationPayments from "./routes/ApplicationPayments";
import {sessionExpired} from "../actions/signOut";

class App extends React.Component {

    onIdle() {
        if (this.props.authenticated) {
            this.props.dispatch(sessionExpired());
        }
    }

    render() {
        return <Router>
            <Container className="h100 p1">
                {this.props.authenticated && this.props.email
                && <div className="user-info">Jesteś zalogowany jako <strong>{this.props.email}</strong></div>}
                {this.props.authenticated && <Navigation/>}
                {this.props.authenticated && <IdleTimer element={document}
                                                        timeout={1000 * 60 * 15}
                                                        onIdle={() => {
                                                            this.onIdle()
                                                        }}/>}
                <Route path="/" exact component={Dashboard}/>
                <Route path="/zgloszenia" exact component={ApplicationList}/>
                <Route path="/zgloszenia/:applicationId" exact component={Application}/>
                <Route path="/zgloszenia/:applicationId/oplaty" exact component={ApplicationPayments}/>
                <Route path="/zawodnicy" exact component={Participants}/>

                <Route path="/logowanie" exact component={SignIn}/>
                <Route path="/logowanie/:token" exact component={SignInByToken}/>
                <Route path="/rejestracja" exact component={SignUp}/>
                <Route path="/rejestracja/:token" exact component={SignUp}/>
                <Route path="/resetowanie-hasla" exact component={PasswordRecovery}/>
                <Route path="/resetowanie-hasla/:token" exact component={PasswordRecovery}/>
            </Container>
        </Router>
    }
}

function mapStateToProps(state) {
    return {
        authenticated: state.session.authenticated,
        email: state.session.email
    }
}

export default connect(mapStateToProps)(App)


// WEBPACK FOOTER //
// ./src/components/App.js